import carousel from '../components/carousel';
import EnhancedSeo from '../enhancedSeo';
import Product from '../product';
import Seo from '../components/seo.js';

class Quickview {
  constructor() {
    Product.colorAttribute();
    Product.selectAttribute();
    Product.availability();
    Product.addToCart();
  }

  run() {
    this.showQuickview();
    this.closedModal();
    this.hideDialog();
  }

  defaultColor(selectedProduct) {
      var self = this;
      if ($('.quick-view-modal .swatch-color.selectable').length !== 0) {
          if (!$('.quick-view-modal .swatch-color.selected').length) {
            let defaultPid = selectedProduct.split('_')[1];
              $('.quick-view-modal .swatch-color.selectable[data-attr-value='+defaultPid+']').click()
          } else {
              // Trigger size selection if the color is selected upon page load (i.e. when dw_xxx_color is in the request params)
              self.selectSingleSize();
          }
      }
      EnhancedSeo.clickQuickViewProduct(['.modal-content', '.product-quickview', 'pid', '.quick-view-modal .swatch-color.selectable', 'data-family-color-search']);
  }

  selectSingleSize() {
    if ($('.quick-view-modal .swatch-color.selected').length) {
      var sizes = $('.quick-view-modal .attribute .list-size').find('li');
      var sizesSelected = $('.quick-view-modal .attribute .list-size').find('li.selected');
      if (sizes.length === 1 && sizesSelected.length === 0) {
        sizes[0].click();
      }
    }
  }

  triggerSelectionOfSingleSize() {
    var self = this;
    $('body').on('product:afterAttributeSelect', (e) => {
      // trigger only if we have a color selected
      self.selectSingleSize();
    });
  }

  showQuickview() {
    $('body').on('click', '.quickview', (event) => {
      event.preventDefault();
      const selectedValueUrl = $(event.currentTarget).closest('a.quickview').attr('href');
      const selectedProduct = $(event.currentTarget).closest('.selected-product').data('container');
      const productUrl = selectedValueUrl.replace('Product-ShowQuickView', 'Product-Show');

      $(event.target).trigger('quickview:show');
      this.fillModalElement(productUrl, selectedValueUrl, selectedProduct);
    });
  }

  closedModal() {
    $(document).on('closed.zf.reveal', '#quickViewModal', () => {
      $('.product-quickview .swatch-color').off('click.quickview');
      $('#quickViewModal .modal-body').empty();
    });
  }

  fillModalElement(productUrl, selectedValueUrl, selectedProduct) {
    $.ajax({
      url: selectedValueUrl,
      method: 'GET',
      dataType: 'html',
      success: (html) => {
        const parsedHtml = this.parseHtml(html);

        $('.modal-body').empty().html(parsedHtml.body);
        $('.pdp-link').attr('href', productUrl);
        this.updateAttributes();
        this.defaultColor(selectedProduct);
        this.triggerSelectionOfSingleSize();
        this.pdpLinkOnColorSelection();
        this.pdpLinkOnSizeSelection();
        carousel.quickviewCarousel();
        Seo.wishlist();
      }
    });
  }

  /**
   * function for managing full productpage link in quickview modal
   * link changes based on the color variation selected by the user, if any
   * @returns {void}
   */
  pdpLinkOnColorSelection() {
    $('.product-quickview .swatch-color').on('click.quickview', (e) => {
      var fullPdp = $('.product-quickview').find('.full-pdp-link a');
      var hrefQs = $(e.currentTarget).attr('href').split('?');

      if (hrefQs.length > 1) {
        hrefQs = hrefQs[1];
        if (fullPdp.length > 0) {
          var destinationQS = fullPdp.attr('href').split('?');
          if (destinationQS.length > 1) {
            destinationQS = destinationQS[0] + '?' + hrefQs;
            fullPdp.attr('href', destinationQS);
          }
        }
      }
    });
  }

  /**
   * function for managing full productpage link in quickview modal
   * link changes based on the size variation selected by the user, if any
   * @returns {void}
   */
  pdpLinkOnSizeSelection() {
    $('.product-quickview .list-size .default').on('click.quickview', (e) => {
      var fullPdp = $('.product-quickview').find('.full-pdp-link a');
      var hrefQs = $(e.currentTarget).attr('data-url-value').split('?');

      if (hrefQs.length > 1) {
        hrefQs = hrefQs[1];
        if (fullPdp.length > 0) {
          var destinationQS = fullPdp.attr('href').split('?');
          if (destinationQS.length > 1) {
            destinationQS = destinationQS[0] + '?' + hrefQs;
            fullPdp.attr('href', destinationQS);
          }
        }
      }
    });
  }

  parseHtml(html) {
    const $html = $('<div>').append($.parseHTML(html));
    const body = $html.find('.product-quickview');
    return {
      body: body
    };
  }

  hideDialog() {
    $('body').on('product:afterAddToCart', () => {
      $('#quickViewModal').foundation('close');
    });
  }

  updateAttributes() {
    $('body').on('product:afterAttributeSelect', (e, response) => {
      const pdplink = $('#pdp-link');
      const link = pdplink.attr('href').replace(/\?pid=.*/g, `?pid=${response.data.product.id}`).replace('Product-Show','Product-Variation');

      $(response.container).attr('data-pid', response.data.product.id);
      pdplink.attr('href', link);
    });
  }
}

const quickview = new Quickview();
export default quickview;



// WEBPACK FOOTER //
// ./assets/scripts/quickview/index.js